<template>
<div>
  


      <div class="rounded-lg shadow border border-white bg-white">
            <div class="row justify-content-centre align-items-center ">    

            <h4 class="col ml-3 font-weight-lighter text-info"> <span class="fa fa-folder"></span> Gestion Des Départements    </h4> 
            

                <div class="col">
                                                         <b-button pill size="sm"  class="m-3 float-right" variant="outline-success" @click="pointeuses_Click">
                                                <i class="fa fa-plus-square"></i>
                                        <span> Pointeuses</span> 
                                    </b-button>
                                    
                                <b-button pill size="sm"  class="m-3 float-right" variant="success" @click="add_click($event.target)">
                                            <i class="fa fa-plus-square"></i>
                                    <span> Ajouter</span> 
                                </b-button>

                                <b-button pill size="sm"  class="m-3 float-right" variant="info" @click="fetchList">
                                    <i class="fa fa-sync-alt"></i>
                                    <span> Actualiser</span> 
                                </b-button>


                </div>
            </div>
       



        <b-table 
        sort-icon-left
        head-variant="light"
        responsive  
        :fields="fields" 
        :items="itemslist"
        >
            <template #cell(actions)="row">
                    <b-button pill size="sm"  class="mr-2 mt-1 mb-1 float-right" variant="outline-danger" @click="del_click(row.item)">
                                <i class="fa fa-trash-alt"></i>
                        
                    </b-button>
                    <b-button pill size="sm" class="mr-2 mt-1 mb-1 float-right" variant="outline-primary" @click="edit_click(row.item, row.index, $event.target)">
                            <i class="fa fa-pencil-alt"></i>
                    
                    </b-button>
                </template>
        
        </b-table>
      </div>


    <!-- le modal -->
    <b-modal id="banqModal" :title="itemForm.nom"  hide-footer>
           <form @submit.prevent="handleSubmit">
            <div class="form-group">
                <label for="name">Nom Département</label>
                <input type="text" v-model="itemForm.nom" id="name" name="name" class="form-control"
                    :class="{ 'is-invalid': isSubmitted && $v.itemForm.nom.$error }" />
                <div v-if="isSubmitted && !$v.itemForm.nom.required" class="invalid-feedback">Ce champ est obligatoire !!</div>
            </div>




            <div class="form-group">
            <label for="Description">Description</label>
            <textarea name="description" id="description"  rows="4" class="form-control" v-model="itemForm.description"></textarea>

            </div>


            

                            
                                            <label for="pointeuse_id">Pointeuse :</label>
                                            <select class="form-control" id="pointeuse_id" v-model="itemForm.pointeuse_id"
                                            :class="{ 'is-invalid': isSubmitted && $v.itemForm.pointeuse_id.$error }">
                                            <option v-for="item in Pointeuselist" :key="item.id" v-bind:value="item.id">   
                                                {{ item.nom }}
                                            </option>
                                            </select>

                                <div v-if="isSubmitted && !$v.itemForm.pointeuse_id.required" class="invalid-feedback">Ce champ est obligatoire !!</div>

                       
                        
                                <div class="custom-control custom-switch mt-2 mb-2">
                                <input type="checkbox"
                                class="custom-control-input" 
                                id="abonne"
                                        v-model="itemForm.equipe"
                                        name="abonne"
                                        value=true
                                        unchecked-value=false

                                >

                                <label class="custom-control-label" for="abonne">Equipe</label>
                                </div>






            <div class="form-group">
                <button type="submit" class="btn  btn-primary btn-block">{{ModalType}}</button>
            </div>


        </form>
    </b-modal>

    <!-- les trucs public -->
    

 <b-modal  id="catmodal" title="Pointeuses"  hide-footer>

            <form @submit.prevent="handleSubmitPoint">

                            <div class="form-group">
                                <label for="currentPointeuse">Nom Pointeuse :</label>
                                <input type="text" v-model="currentPointeuse" id="currentPointeuse" name="currentPointeuse" class="form-control" />

                            </div>

            <div class="form-group">
                <button type="submit" class="btn  btn-primary btn-block">Ajouter</button>
            </div>

        </form>



        <b-table 
        sort-icon-left
        small 
        sticky-header
        :fields="fieldsPoint" 
        :items="Pointeuselist"
        >
            <template #cell(actions)="row">
                    <b-button pill size="sm"  class="mr-2 float-right" variant="outline-danger" @click="del_categclick(row.item)">
                                <i class="fa fa-trash-alt"></i>
                        
                    </b-button>
            </template>
        
        </b-table>


</b-modal>

    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#0179F9" loader='bars'></loading>


</div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {required} from "vuelidate/lib/validators";

export default {

    mounted(){
        this.fetchList()
    },
	data () {
		return {
            fieldsPoint: [
                {key: 'nom', label: 'Pointeuse', sortable: true},
                { key: 'actions', label: '' }
            ],
            Pointeuselist: [],
            currentPointeuse:'',
            itemslist: [],
            itemForm: {
                    id:'',
                    nom:'',
                    equipe:false,
                    description:'',
                    pointeuse_id:''},
            fields: [
				{key: 'nom', label: 'Nom', sortable: true},
                {key: 'description', label: 'Description', sortable: true},
                {key: 'equipe', label: 'Equipe', 
                formatter: (value) => {
                 return value ? 'Oui' : 'Non'
                }, sortable: true},
                {key: 'pointeuse', label: 'Pointeuse', sortable: true},

                { key: 'actions', label: '' }
            ],
            //public trucs
            ModalEdit: false,
            ModalType:'Ajouter',
            isSubmitted: false,
            isLoading: false
		}
	},
    validations: {
            itemForm: {
                nom: {
                    required
                },
                equipe: {
                    required
                },
                pointeuse_id: {
                    required
                },

                

            }
    },
    methods :{
//les pionteuses :


        pointeuses_Click()
        {

        this.currentPointeuse=''
        this.$root.$emit('bv::show::modal', 'catmodal')

        },
        handleSubmitPoint() {

            if(this.currentPointeuse)
            {
                this.itemslisttorePoint(this.currentPointeuse)

            }
            else
            {
                this.flashMessage.show({
                status: 'info',
                title: 'Entrez un type de dépense !!',
                })

            }
        },
        itemslisttorePoint(nm){
                        this.isLoading=true;

            this.$http.post('/pointeuses',{
            nom:nm

                })
                .then(response => {

                    this.isLoading=false;
                    this.Pointeuselist.unshift(response.data.data);

                    //afficher message
                    this.flashMessage.show({
                    status: 'success',
                    title: 'Données sauvegardées',
                    message: 'Les données sont sauvegardées correctement '
                })


                })
                .catch(error=> {console.log(error)
                this.isLoading=false;


                                this.flashMessage.show({
                status: 'error',
                title: 'Erreur De Sauvegarde',
                message: 'Impossible  de sauvegarder les données .. Réessayez !!'
                })
                });

        },
        del_categclick(itm) {

                this.$confirm("Voulez-vous vraiment supprimer cet élément ?? Attention si cet élément est déjà utilisé ,vous NE pouvez PAS le supprimer")
                 .then(() => {


            this.isLoading=true;

            this.$http.delete('/pointeuses/'+itm.id)
                .then(response => {
                console.log(response.data)
                this.isLoading=false;   
                this.flashMessage.show({
                status: 'success',
                title: 'Données Supprimées',
                message: 'Les données sont supprimées correctement'
                })


                    let index = this.Pointeuselist.findIndex(item => item.id === itm.id)


                   this.Pointeuselist.splice(index, 1)




                    })
                .catch(error=> {console.log(error)
                this.isLoading=false;


                this.flashMessage.show({
                status: 'error',
                title: 'Erreur De Suppression',
                message: 'Impossible  de supprimer les données .. Réessayez !!'
                })
                });
                                })

                  //erreur de dialog              
                .catch(error=> {
                console.log(error)

                });




        },


// le departements
        itemslisttore(){
                        this.isLoading=true;

            this.$http.post('/departements',{
            nom:this.itemForm.nom,
            equipe:this.itemForm.equipe,
            description:this.itemForm.description,
            pointeuse_id:this.itemForm.pointeuse_id

                })
                .then(response => {

                    this.isLoading=false;
                    this.itemslist.unshift(response.data.data);
                    this.$bvModal.hide('banqModal')

                    //afficher message
                    this.flashMessage.show({
                    status: 'success',
                    title: 'Données sauvegardées',
                    message: 'Les données sont sauvegardées correctement '
                })


                })
                .catch(error=> {console.log(error)
                this.isLoading=false;


                                this.flashMessage.show({
                status: 'error',
                title: 'Erreur De Sauvegarde',
                message: 'Impossible  de sauvegarder les données .. Réessayez !!'
                })
                });

        },
        banqueEdit(){

            this.isLoading=true;

            this.$http.patch('/departements/'+this.itemForm.id,{
            nom:this.itemForm.nom,
            equipe:this.itemForm.equipe,
            description:this.itemForm.description,
            pointeuse_id:this.itemForm.pointeuse_id,


                })
                .then(response => {

                    this.isLoading=false;
                    console.log(response.data)
                    this.$bvModal.hide('banqModal')

                    let index = this.itemslist.findIndex(item => item.id === this.itemForm.id)
                    this.itemslist.splice(index, 1,response.data.data)
                    
                    this.flashMessage.show({
                    status: 'success',
                    title: 'Données modifiées',
                    message: 'Les données sont modifiées correctement'
                    })


                    })
                    .catch(error=> {console.log(error)
                    this.isLoading=false;


                    this.flashMessage.show({
                    status: 'error',
                    title: 'Erreur De Modification',
                    message: 'Impossible  de modifier les données .. Réessayez !!'
                })
                });

        },
        banqueDell(){

            this.isLoading=true;

            this.$http.delete('/departements/'+this.itemForm.id)
                .then(response => {
                console.log(response.data)
                    this.isLoading=false;



                    
                this.flashMessage.show({
                status: 'success',
                title: 'Données Supprimées',
                message: 'Les données sont supprimées correctement'
                })


                    let index = this.itemslist.findIndex(item => item.id === this.itemForm.id)
                    this.itemslist.splice(index, 1)




                    })
                .catch(error=> {console.log(error)
                this.isLoading=false;


                this.flashMessage.show({
                status: 'error',
                title: 'Erreur De Suppression',
                message: 'Impossible  de supprimer les données .. Réessayez !!'
                })
                });

        },
        add_click(button) {
        this.itemForm.id=''
        this.itemForm.nom=''
        this.itemForm.equipe=false,
        this.itemForm.description=''
        this.itemForm.pointeuse_id=''


        this.ModalEdit=false;
        this.ModalType='Ajouter'

        this.$root.$emit('bv::show::modal', 'banqModal', button)
        },
        edit_click(item, index, button) {

                this.$confirm("Voulez-vous vraiment modifier cet élément ??")
                 .then(() => {
                this.itemForm.id=item.id
                this.itemForm.nom=item.nom
                this.itemForm.equipe=item.equipe,
                this.itemForm.description=item.description
                this.itemForm.pointeuse_id=item.pointeuse_id

                this.ModalEdit=true;
                this.ModalType='Modifier'

                this.$root.$emit('bv::show::modal', 'banqModal', button)
                })
                .catch(error=> {
                console.log(error)

                });


        },
        del_click(item) {

                this.$confirm("Voulez-vous vraiment supprimer cet élément ??")
                 .then(() => {
                this.itemForm.id=item.id
                        this.banqueDell()
                                })
                                .catch(error=> {
                                console.log(error)

                                    });




        },
        fetchList: function () {
                    this.isLoading=true;
                    this.$http.get('/departements')
                    .then((result) => {
                                this.itemslist = result.data.data
                                this.isLoading=false;
                    })
                    .catch(error=> {
                                console.log(error)
                                this.isLoading=false;
                                this.flashMessage.show({
                                status: 'error',
                                title: 'Erreur de Chargement',
                                message: 'Impossible charger les données.. Actualisez et Réessayez'
                                })
                    });


                    //Pointeuses :
                    this.isLoading=true;
                    this.$http.get('/pointeuses')
                    .then((result) => {
                                this.Pointeuselist = result.data.data
                                this.isLoading=false;
                    })
                    .catch(error=> {
                                console.log(error)
                                this.isLoading=false;
                                this.flashMessage.show({
                                status: 'error',
                                title: 'Erreur de Chargement',
                                message: 'Impossible charger les données.. Actualisez et Réessayez'
                                })
                    }); 
        },
        handleSubmit() {
                this.isSubmitted = true;

                this.$v.$touch();
                if (this.$v.$invalid) {
                this.flashMessage.show({
                status: 'info',
                title: 'Vérifiez les données et Reésayez !!',
                })
                }
                else 
                {


                            if(this.ModalEdit)
                            {
                                this.banqueEdit()
                            }
                            else
                            {

                                this.itemslisttore()
                            }   

                }

        }

    },
    components: {
              Loading      
    }
}
</script>

<style  scoped>

</style>